module.exports = __webpack_public_path__ + "static/media/edit.596ce5c3.svg";